<!-- TODO: la page est trop longues, trop d'intelligences différentes, il faut découper en components enfants.-->
<div class="page-layout simple fullwidth inner-scroll mat-white-bg" fusePerfectScrollbar>

  <!-- HEADER -->
  @if (displayHeader) {
    <div class="header p-24" fxLayout="row" fxLayoutAlign="start center">
      @if (displayHeaderTitle) {
        <h2>{{'dashboard.title' | translate}}</h2>
      }
    </div>
  }
  <!-- / HEADER -->

  @if (empty) {
    <div fxFlex="100" fxLayout="column" fxLayoutAlign="center center" fxLayoutGap="12px">
      <mat-icon class="iconEmptyWidget" svgIcon="chat_sad"></mat-icon>
      <label>{{ 'generic.empty_widget' | translate }}</label>
      <label>{{ 'generic.to_take_over_resources' | translate }}</label>
      <button mat-raised-button
        class="mat-accent"
        (click)="goToHelpPage()">
        {{ 'generic.read_the_tutorials' | translate }}
      </button>
    </div>
  }
  @if (!empty) {
    <div class="content inner-scroll touch-scroll">
      @if (!displayTabsPage()) {
        <div fxLayout="column">
          @if (haveFilters) {
            <div> <!-- TODO unnecessary div -->
              <mat-toolbar class="filters group">
                <mat-toolbar-row fxLayoutGap="24px">
                  <!-- Groups Field -->
                  @if (authService.isAtLeastTrainer() && displayFilter('group')) {
                    <mat-form-field appMoveElement
                      [movableElementIsActive]="orderFields"
                      [movableElementFields]="fields" [movableElementField]="'group'"
                      >
                      <mat-select placeholder="{{ 'filter.group' | translate }}" [formControl]="groupControl" data-e2e="dashboard-group">
                        <mat-option value="all">{{'generic.all' | translate}}</mat-option>
                        @for (group of groups; track group) {
                          <mat-option
                          [value]="group">{{ group.groupname }}</mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                  }
                </mat-toolbar-row>
              </mat-toolbar>
            </div>
          }
          <div class="dash-widget-wrapper-parent" fxFlex fxLayout="column" fxLayoutAlign="start start">
            <!-- TODO unnecessary div flex -->
            <div class="dash-widget-wrapper" fxLayout="row wrap" fxLayout.xs="column">
              <!-- TODO unnecessary div flex -->
              <!-- dash-widget-project -->
              @if (isWidgetAllowed('project')) {
                <app-dash-widget
                  appMoveElement
                  [movableElementIsActive]="orderFields"
                  [movableElementFields]="fields" [movableElementField]="'project'"
                  [DashWidgetConf]="DashWidgetConfProjectsManagement"
                  class="{{ DashWidgetConfProjectsManagement.dashWidgetClassName }}">
                  <app-dashwidget-project widgetCard
                  [projectsSubscription]="projectsSubscription"></app-dashwidget-project>
                </app-dash-widget>
              }
              <!-- dash-widget-group -->
              @if (isWidgetAllowed('group')) {
                <app-dash-widget
                  [DashWidgetConf]="DashWidgetConfGroupsManagement"
                  class="{{ DashWidgetConfGroupsManagement.dashWidgetClassName }}">
                  <app-dashwidget-group widgetCard
                  [groupsSubscription]="groupsSubscription"></app-dashwidget-group>
                </app-dash-widget>
              }
              <!-- dash-widget-workgroup -->
              @if (authService.hasLevel(['learner']) && isWidgetAllowed('workgroup')) {
                <app-dash-widget
                  [DashWidgetConf]="DashWidgetConfWorkgroupsManagement"
                  class="{{ DashWidgetConfWorkgroupsManagement.dashWidgetClassName }}">
                  <app-widget-workgroup widgetCard
                  [workgroupsSubscription]="workgroupsSubscription"></app-widget-workgroup>
                </app-dash-widget>
              }
              <!-- dash-widget-recommendation -->
              @if (isWidgetAllowed('recommendation')) {
                <app-dash-widget
                  appMoveElement
                  [movableElementIsActive]="orderFields"
                  [movableElementFields]="fields" [movableElementField]="'recommendation'"
                  [DashWidgetConf]="DashWidgetConfRecommendation"
                  class="{{ DashWidgetConfRecommendation.dashWidgetClassName }}">
                  <app-dynamic widgetCard room="recommendation" subject="recommendationListComponent" [params]="{options: {limit: 5, redirectUrl: '/lessons/list/recommendation'}}"></app-dynamic>
                </app-dash-widget>
              }
              <!-- dash-widget-news -->
              @if (isWidgetAllowed('news')) {
                <app-dash-widget
                  appMoveElement
                  [movableElementIsActive]="orderFields"
                  [movableElementFields]="fields" [movableElementField]="'news'"
                  [DashWidgetConf]="DashWidgetConfNews"
                  class="{{ DashWidgetConfNews.dashWidgetClassName }}">
                  <app-dynamic widgetCard room="news" subject="newsListComponent"></app-dynamic>
                </app-dash-widget>
              }
              <!-- dash-widget-agenda-weekly -->
              @if (isWidgetAllowed('agenda-weekly')) {
                <app-dash-widget
                  appMoveElement
                  [movableElementIsActive]="orderFields"
                  [movableElementFields]="fields" [movableElementField]="'agenda-weekly'"
                  [DashWidgetConf]="DashWidgetConfAgendaWeeklyManagement"
                  class="{{ DashWidgetConfAgendaWeeklyManagement.dashWidgetClassName }}">
                  <app-dynamic widgetAccordion room="agenda" subject="agendaWeeklyComponent"></app-dynamic>
                </app-dash-widget>
              }
              <!-- dash-widget-favorites-lessons  -->
              @if (isWidgetAllowed('favorites-lessons')) {
                <app-dash-widget
                  [DashWidgetConf]="DashWidgetConfFavoritesLessonsManagement"
                  class="{{ DashWidgetConfFavoritesLessonsManagement.dashWidgetClassName }}">
                  <app-dynamic widgetCard room="lessons" subject="lessonsFavoritesComponent"></app-dynamic>
                </app-dash-widget>
              }
              <!-- dash-widget-favorites-corpus -->
              @if (isWidgetAllowed('favorites-corpus')) {
                <app-dash-widget
                  [DashWidgetConf]="DashWidgetConfFavoritesCorpusManagement"
                  class="{{ DashWidgetConfFavoritesCorpusManagement.dashWidgetClassName }}">
                  <!-- <app-corpus-favorites widgetCard></app-corpus-favorites> -->
                  <app-dynamic widgetCard room="corpus" subject="corpusFavoritesComponent"></app-dynamic>
                </app-dash-widget>
              }
              @if (isWidgetAllowed('consulted-corpus')) {
                <app-dash-widget
                  [DashWidgetConf]="DashWidgetConfConsultedCorpusManagement"
                  class="{{ DashWidgetConfConsultedCorpusManagement.dashWidgetClassName }}">
                  <!-- <app-corpus-favorites widgetCard></app-corpus-favorites> -->
                  <app-dynamic widgetCard room="corpus" subject="corpusConsultedComponent"></app-dynamic>
                </app-dash-widget>
              }
              @if (isWidgetAllowed('created-corpus')) {
                <app-dash-widget
                  [DashWidgetConf]="DashWidgetConfCreatedCorpusManagement"
                  class="{{ DashWidgetConfCreatedCorpusManagement.dashWidgetClassName }}">
                  <!-- <app-corpus-favorites widgetCard></app-corpus-favorites> -->
                  <app-dynamic widgetCard room="corpus" subject="corpusCreatedComponent"></app-dynamic>
                </app-dash-widget>
              }
              <!-- dash-widget-MessageThreads -->
              @if (isWidgetAllowed('MessageThreads')) {
                <app-dash-widget appMoveElement
                  [movableElementIsActive]="orderFields"
                  [movableElementFields]="fields" [movableElementField]="'MessageThreads'"
                  [DashWidgetConf]="DashWidgetConfMessageThreadsManagement"
                  class="{{ DashWidgetConfMessageThreadsManagement.dashWidgetClassName }}">
                  <app-dashwidget-message widgetAccordion
                  [messageThreadsSubscription]="messageThreadsSubscription"></app-dashwidget-message>
                </app-dash-widget>
              }
              <!-- ------ dash-widget-sheetModels   &&   dash-widget-formModels ------ -->
              <!-- ------------------------------------------------------------------------- -->
              @if (authService.isAtLeastTrainer() && isWidgetAllowed('sheetModels') || isWidgetAllowed('formModels')) {
                <div
                  fxFlex fxLayout="row wrap" fxLayout.xs="column"
                  class="dash-widget-group">
                  <!-- dash-widget-sheetModels -->
                  @if (isWidgetAllowed('sheetModels')) {
                    <app-dash-widget appMoveElement
                      [movableElementIsActive]="orderFields"
                      [movableElementFields]="fields" [movableElementField]="'sheetModels'"
                      [DashWidgetConf]="DashWidgetConfResearchSheetTemplate"
                      class="{{ DashWidgetConfResearchSheetTemplate.dashWidgetClassName }}">
                      <app-widget-research-sheet-models widgetCard
                      [sheetTemplateSubscription]="sheetTemplateSubscription"></app-widget-research-sheet-models>
                    </app-dash-widget>
                  }
                  <!-- dash-widget-formModels -->
                  @if (isWidgetAllowed('formModels')) {
                    <app-dash-widget
                      appMoveElement
                      [movableElementIsActive]="orderFields"
                      [movableElementFields]="fields" [movableElementField]="'formModels'"
                      [DashWidgetConf]="DashWidgetConfFormModels"
                      class="{{ DashWidgetConfFormModels.dashWidgetClassName }}">
                      <!-- <app-widget-form-models widgetCard [formModelsSubscription]="formModelsSubscription"></app-widget-form-models> -->
                    </app-dash-widget>
                  }
                </div>
              }
              <!-- ------ dash-widget-assignmentsGroup   &&   dash-widget-assignments ------ -->
              <!-- ------------------------------------------------------------------------- -->
              <div fxFlex fxLayout="column" class="dash-widget-group assignments-widget-Group"
                appMoveElement
                [movableElementIsActive]="orderFields"
                [movableElementFields]="fields" [movableElementField]="'assignementsContainer'">
                <!-- dash-widget-assignmentsGroup -->
                @if (authService.isAtLeastTrainer() && !authService.hasLevel(['manager']) && isWidgetAllowed('assignmentsGroup')) {
                  <app-dash-widget
                    [DashWidgetConf]="DashWidgetConfAssignmentsGroup"
                    class="{{ DashWidgetConfAssignmentsGroup.dashWidgetClassName }}">
                    <app-widget-assignments-group widgetAccordion
                    [assignmentsGroupsSubscription]="assignmentsGroupsSubscription"></app-widget-assignments-group>
                  </app-dash-widget>
                }
                <!-- dash-widget-assignments all assignment-->
                @if (isWidgetAllowed('assignments')) {
                  <app-dash-widget
                    [DashWidgetConf]="DashWidgetConfAssignments"
                    class="{{ DashWidgetConfAssignments.dashWidgetClassName }}">
                    <app-dynamic widgetAccordion room="assignation"
                    subject="widgetAssignmentsLessonComponent"></app-dynamic>
                  </app-dash-widget>
                }
                <!-- dash-widget-assignments list of learner without active assignement -->
                @if (authService.loggedUser && isWidgetAllowed('learnersWithoutAssignments')) {
                  <app-dash-widget
                    [DashWidgetConf]="DashWidgetConfAssignmentsWithoutAssignment"
                    class="{{ DashWidgetConfAssignmentsWithoutAssignment.dashWidgetClassName }}">
                    <app-dynamic widgetAccordion room="assignation"
                      subject="WidgetAssignmentsLearnersWithoutActiveAssignmentComponent"
                    [params]="assignmentsWithoutParams"></app-dynamic>
                  </app-dash-widget>
                }
                <!-- dash-widget-assignments closed only -->
                @if (isWidgetAllowed('assignmentsClosed')) {
                  <app-dash-widget
                    [DashWidgetConf]="DashWidgetConfAssignmentsClosed"
                    class="{{ DashWidgetConfAssignmentsClosed.dashWidgetClassName }}">
                    <app-dynamic widgetAccordion room="assignation" [params]="assignmentsClosedParams"
                    subject="widgetAssignmentsLessonComponent"></app-dynamic>
                  </app-dash-widget>
                }
              </div>
              @if (isWidgetAllowed('analytics')) {
                <div appMoveElement
                  [movableElementIsActive]="orderFields"
                  [movableElementFields]="fields" [movableElementField]="'analytics'"
                  class="cards card-mini" fxLayout="row" fxFlex="100"
                  fxLayoutAlign="start start" fusePerfectScrollbar>
                  @for (analytic of analyticsDetails; track analytic) {
                    <div class="p-16" fxLayout="column"
                      fxLayoutAlign="center center" fxFlex="auto" fxFlex.gt-md="25" fxFlex.gt-lg="25">
                      <mat-card class="mat-elevation-z0">
                        <mat-card-content class="p-16" [ngClass]="{'learner': backgroundLearner(analytic)}"
                          fxLayout="column" fxLayoutAlign="center center">
                          <label
                          class="label">{{translateTerm(analytic, 'label', 'string')  | translate}}</label>
                          <label
                          class="value1">{{translateTerm(analytic, 'value', 'number')  | translate}}</label>
                          <div class="label2 value2" fxLayout="row" fxLayoutAlign="center center">
                            (<label>{{translateTerm(analytic, 'label2', 'string') | translate }}</label>&nbsp;:&nbsp;<label>{{translateTerm(analytic, 'value2', 'number')  | translate}}</label>)
                          </div>
                        </mat-card-content>
                      </mat-card>
                    </div>
                  }
                </div>
              }
            </div>
          </div>
        </div>
      }
      @if (displayTabsPage()) {
        <div fxLayout="column">
          <mat-tab-group dynamicHeight="true" [attr.mat-align-tabs]="alignMainDashboardTabs()">
            @if (isWidgetAllowed('favorites-lessons') || isWidgetAllowed('consulted-lessons') ||isWidgetAllowed('created-lessons')) {
              <mat-tab appAriaTitle label="{{ 'activities.title_lessons' | translate }}"
                >
                <!--                TODO: Faire un component enfant de dashboad ici.-->
                @if (dashboardService.settings.displaySentenceBeforeHeader) {
                  <h2>{{ 'dashboard.find_here_lessons' | translate }}</h2>
                }
                @if (isWidgetAllowed('favorites-lessons')) {
                  <app-dash-widget
                    appMoveElement
                    [movableElementIsActive]="orderFields"
                    [movableElementFields]="fields" [movableElementField]="'favorites-lessons'"
                    [DashWidgetConf]="DashWidgetConfFavoritesLessons"
                    class="{{ DashWidgetConfFavoritesLessons.dashWidgetClassName }}">
                    <app-dynamic widgetCard room="lessons" subject="lessonsFavoritesComponent"></app-dynamic>
                  </app-dash-widget>
                }
                @if (isWidgetAllowed('consulted-lessons')) {
                  <app-dash-widget
                    appMoveElement
                    [movableElementIsActive]="orderFields"
                    [movableElementFields]="fields" [movableElementField]="'consulted-lessons'"
                    [DashWidgetConf]="DashWidgetConfConsultedLessons"
                    class="{{ DashWidgetConfConsultedLessons.dashWidgetClassName }}">
                    <app-dynamic widgetCard room="lessons" subject="lessonsConsultedComponent"></app-dynamic>
                  </app-dash-widget>
                }
                @if (isWidgetAllowed('created-lessons')) {
                  <app-dash-widget
                    appMoveElement
                    [movableElementIsActive]="orderFields"
                    [movableElementFields]="fields" [movableElementField]="'created-lessons'"
                    [DashWidgetConf]="DashWidgetConfCreatedLessons"
                    class="{{ DashWidgetConfCreatedLessons.dashWidgetClassName }}">
                    <app-dynamic widgetCard room="lessons" subject="lessonsCreatedComponent"></app-dynamic>
                  </app-dash-widget>
                }
              </mat-tab>
            }
            @if (isWidgetAllowed('favorites-corpus') || isWidgetAllowed('consulted-corpus') ||isWidgetAllowed('created-corpus')) {
              <mat-tab appAriaTitle label="{{ 'activities.title_resources' | translate }}"
                >
                @if (dashboardService.settings.displaySentenceBeforeHeader) {
                  <h2>{{ 'dashboard.find_here_resources' | translate }}</h2>
                }
                @if (isWidgetAllowed('favorites-corpus')) {
                  <app-dash-widget
                    appMoveElement
                    [movableElementIsActive]="orderFields"
                    [movableElementFields]="fields" [movableElementField]="'favorites-corpus'"
                    [DashWidgetConf]="DashWidgetConfFavoritesCorpusManagement"
                    class="{{ DashWidgetConfFavoritesCorpusManagement.dashWidgetClassName }}">
                    <app-dynamic widgetCard room="corpus" subject="corpusFavoritesComponent"></app-dynamic>
                  </app-dash-widget>
                }
                @if (isWidgetAllowed('consulted-corpus')) {
                  <app-dash-widget
                    appMoveElement
                    [movableElementIsActive]="orderFields"
                    [movableElementFields]="fields" [movableElementField]="'consulted-corpus'"
                    [DashWidgetConf]="DashWidgetConfConsultedCorpusManagement"
                    class="{{ DashWidgetConfConsultedCorpusManagement.dashWidgetClassName }}">
                    <app-dynamic widgetCard room="corpus" subject="corpusConsultedComponent"></app-dynamic>
                  </app-dash-widget>
                }
                @if (isWidgetAllowed('created-corpus')) {
                  <app-dash-widget
                    appMoveElement
                    [movableElementIsActive]="orderFields"
                    [movableElementFields]="fields" [movableElementField]="'created-corpus'"
                    [DashWidgetConf]="DashWidgetConfCreatedCorpusManagement"
                    class="{{ DashWidgetConfCreatedCorpusManagement.dashWidgetClassName }}">
                    <app-dynamic widgetCard room="corpus" subject="corpusCreatedComponent"></app-dynamic>
                  </app-dash-widget>
                }
              </mat-tab>
            }
          </mat-tab-group>
        </div>
      }
    </div>
  }

</div>
